(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1249px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  function setupAllPredictiveSearches() {
    const allSearchContainers = document.querySelectorAll('[data-predictive-search-container]');

    if (allSearchContainers.length === 0) {
      console.log("DEBUG: Nenhum container de busca encontrado, mesmo após a espera.");
      return; // Aborta se nada for encontrado
    }

    console.log(`DEBUG: Encontrados ${allSearchContainers.length} containers de busca. Configurando...`);

    allSearchContainers.forEach(searchContainer => {
      const searchInput = searchContainer.querySelector('[data-predictive-search-input]');
      const searchResultsContainer = searchContainer.querySelector('[data-predictive-search-results]');
      let searchTimeout;

      if (!searchInput || !searchResultsContainer) return;

      const fetchAndRenderResults = (query) => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
          .then(response => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.json();
          })
          .then(data => {
            const products = data.resources.results.products;
            searchResultsContainer.innerHTML = '';
            console.log('DEBUG: Produtos encontrados:', products);

            if (products && products.length > 0) {
              products.forEach(product => {
                const format = (value) => parseFloat(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                const priceMin = parseFloat(product.price_min);
                const priceMax = parseFloat(product.price_max);
                const compareMin = parseFloat(product.compare_at_price_min);
                const compareMax = parseFloat(product.compare_at_price_max);
                let priceHtml = '';
                priceHtml = (priceMin !== priceMax) ? `<span class="predictive-search-item__price">${format(priceMin)}</span>` : `<span class="predictive-search-item__price">${format(priceMin)}</span>`;
                if (compareMax > priceMax || compareMin > priceMin) {
                  priceHtml = `<s class="old_price_predictive">${format(compareMax)}</s> ${priceHtml}`;
                }
                const itemHtml = `<a href="${product.url}" class="predictive-search-item"><img src="${product.image}" alt="${product.title}" class="predictive-search-item__image" width="50" height="50"><div class="predictive-search-item__info"><p class="predictive-search-item__title">${product.title}</p><div class="predictive-price-search">${priceHtml}</div></div></a>`;
                searchResultsContainer.insertAdjacentHTML('beforeend', itemHtml);
              });
              showResults();
            } else {
              hideResults();
            }
          })
          .catch(error => {
            console.error('DEBUG: Erro no processo de busca preditiva:', error);
            hideResults();
          });
      };

      const showResults = () => {
        searchResultsContainer.hidden = false;
        searchInput.setAttribute('aria-expanded', 'true');
        searchContainer.querySelector('.search-form-v2').classList.add('expanded');
      };

      const hideResults = () => {
        searchResultsContainer.hidden = true;
        searchInput.setAttribute('aria-expanded', 'false');
        searchContainer.querySelector('.search-form-v2').classList.remove('expanded');
      };

      searchInput.addEventListener('input', () => {
        const query = searchInput.value.trim();
        clearTimeout(searchTimeout);
        if (query.length < 2) {
          hideResults();
          return;
        }
        searchTimeout = setTimeout(() => fetchAndRenderResults(query), 300);
      });

      document.addEventListener('click', (event) => {
        if (!searchContainer.contains(event.target)) {
          hideResults();
        }
      });
    });
  }

  // 2. Criamos o "vigia" que executa quando a página carregar.
  window.addEventListener('load', () => {
    let attempts = 0;
    const maxAttempts = 50; // Tenta por 5 segundos no máximo (50 * 100ms)

    const observerInterval = setInterval(() => {
      const searchContainer = document.querySelector('[data-predictive-search-container]');
      attempts++;

      // Se encontrar o container OU se exceder as tentativas...
      if (searchContainer || attempts >= maxAttempts) {
        clearInterval(observerInterval); // Para o vigia
        console.log("DEBUG: Vigia parou. Tentativas:", attempts);
        setupAllPredictiveSearches(); // Executa nossa função principal
      }
    }, 100);
  });

  // Toggle de busca mobile (search row abaixo da navbar)
  document.addEventListener('DOMContentLoaded', () => {
    const toggle = document.querySelector('[data-mobile-search-toggle]');
    const searchRow = document.querySelector('[data-mobile-search-row]');
    if (!toggle || !searchRow) return;

    toggle.addEventListener('click', () => {
      const isHidden = searchRow.classList.contains('is-hidden');
      if (isHidden) {
        searchRow.classList.remove('is-hidden');
        toggle.setAttribute('aria-expanded', 'true');
        const input = searchRow.querySelector('[data-predictive-search-input]');
        if (input) setTimeout(() => input.focus(), 100);
      } else {
        searchRow.classList.add('is-hidden');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !searchRow.classList.contains('is-hidden')) {
        searchRow.classList.add('is-hidden');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
